import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import {
	TGetNewMessageCountResponsePayload,
	TMessagesResponsePayload,
	TOrganizationsData,
	TOrganizationsRow,
	TUserInfoData,
	TUserStore,
	TUsersListResponsePayload,
	TSaveSessionDataResponsePayload,
} from './types';

export const getUserState = (state: TStoreState): TUserStore => state.user;

export const getUser = createSelector([getUserState], (user: TUserStore) => user);

// ==========================================:

// export const getUserIsLoad = createSelector(
// 	[getUser],
// 	(user: TUserStore): boolean => user.userLoader,
// );

// ==========================================:

export const getUserOrganizations = createSelector(
	[getUser],
	(user: TUserStore): TOrganizationsData => user.organizations,
);

// ==========================================:

export const getUserOrganizationsLoader = createSelector(
	[getUser],
	(user: TUserStore): boolean => user.organizationsLoader,
);

// ==========================================:

export const getUserInfo = createSelector(
	[getUser],
	(user: TUserStore): TUserInfoData => user.userInfo,
);

export const getUserIsAdmin = createSelector(
	[getUserInfo],
	(userInfo: TUserInfoData): boolean =>
		userInfo?.roles?.some((role) => role.roleName === 'admin') ?? false,
);

// ==========================================:

export const getUserInfoLoader = createSelector(
	[getUser],
	(user: TUserStore): boolean => user.userInfoLoader,
);

// ==========================================:

export const getOrganization = createSelector(
	[getUser],
	(user: TUserStore): TOrganizationsRow | null => user.setOrganization,
);

// ==========================================:

export const getNewMessageCount = createSelector(
	[getUser],
	(user: TUserStore): TGetNewMessageCountResponsePayload => user.newMessageCount,
);

// ==========================================:

export const getNewMessageCountLoader = createSelector(
	[getUser],
	(user: TUserStore): boolean => user.newMessageCountLoader,
);

// ==========================================:

export const getMessages = createSelector(
	[getUser],
	(user: TUserStore): TMessagesResponsePayload => user.messages,
);

// ==========================================:

export const getMessagesLoader = createSelector(
	[getUser],
	(user: TUserStore): boolean => user.messagesLoader,
);

// ==========================================:

export const getUsersList = createSelector(
	[getUser],
	(user: TUserStore): TUsersListResponsePayload => user.usersList,
);

// ==========================================:

export const getUsersListLoader = createSelector(
	[getUser],
	(user: TUserStore): boolean => user.usersListLoader,
);

// ==========================================:

export const getSaveSessionId = createSelector(
	[getUser],
	(user: TUserStore): TSaveSessionDataResponsePayload => user.saveSessionId,
);

// ==========================================:

export const getSaveSessionIdLoader = createSelector(
	[getUser],
	(user: TUserStore): boolean => user.saveSessionIdLoader,
);
